{
  "title": "autobrr",
  "username": "Имя пользователя",
  "password": "Пароль",
  "confirmPassword": "Подтвердить пароль",
  "createAccount": "Создать аккаунт",
  "rememberMe": "Запомнить меня",
  "forgotPassword": "Забыли пароль?",
  "forgotPasswordHelp": "Сброс через терминал:",
  "signIn": "Войти",
  "continueWith": "Или продолжить через",
  "openidConnect": "OpenID Connect",
  "errors": {
    "required": "Обязательное поле",
    "usernameRequired": "Требуется имя пользователя",
    "passwordRequired": "Требуется пароль",
    "passwordsDoNotMatch": "Пароли не совпадают!",
    "generic": "Произошла ошибка!",
    "oidcFailed": "Ошибка аутентификации OIDC"
  }
}
